export const CONSTANTS = {
    // REG_EXP_MAIL: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/,
    REG_EXP_MAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
    dayMonths: (d, m) => {
        return (m === 1 && d > 31) || (m === 2 && d > 29) || (m === 3 && d > 31) || (m === 4 && d > 30)
            || (m === 5 && d > 31) || (m === 6 && d > 30) || (m === 7 && d > 31) || (m === 8 && d > 31) || (m === 9 && d > 30)
            || (m === 10 && d > 31) || (m === 11 && d > 30) || (m === 12 && d > 31) || (m === 0 && d === 0) || (d === 0 || m === 0)
            || m > 12;
    },
    entities: [
        { name: 'Activo', code: '1800' },
        { name: 'Santander', code: '0049' },
        { name: 'Santander', code: '0072' },
        { name: 'Santander', code: '0075' },
        { name: 'Sabadell', code: '0081' },
        { name: 'SelfBank', code: '1490' },
        { name: 'BBVA', code: '0182' },
        { name: 'Bankia', code: '2038' },
        { name: 'Kutxabank', code: '2095' },
        { name: 'Caja Laboral', code: '3035' },
        { name: 'Caixabank', code: '2100' },
        { name: 'Caixalqueries', code: '3119' },
        { name: 'CaixaPetrer', code: '3029' },
        { name: 'CaixaRuralAlmenara', code: '3095' },
        { name: 'CaixaRuralBurriana', code: '3112' },
        { name: 'CaixaRuralDeXilxes', code: '3157' },
        { name: 'CaixaRuralNules', code: '3135' },
        { name: 'CaixaRuralTorrent', code: '3118' },
        { name: 'CaixaRuralVilafames', code: '3165' },
        { name: 'CaixaRuralVilareal', code: '3110' },
        { name: 'CaixaRuralVilavilla', code: '3160' },
        { name: 'CaixaSantVicent', code: '3102' },
        { name: 'CaixaTuris', code: '3123' },
        { name: 'Caixa Geral', code: '0130' },
        { name: 'Bankinter', code: '0128' },
        { name: 'Unicaja', code: '2103' },
        { name: 'Deutsche bank', code: '0019' },
        { name: 'Deutsche bank', code: '0145' },
        { name: 'BancaMarch', code: '0061' },
        { name: 'Caixa Geral', code: '0130' },
        { name: 'BNP Bank', code: '0149' },
        { name: 'Barclays', code: '0152' },
        { name: 'Mediolanum', code: '0186' },
        { name: 'Ruralvia', code: '0198' },
        { name: 'Ruralvia', code: '3190' },
        { name: 'CajaRuralAlginet', code: '3179' },
        { name: 'CajaRuralCheste', code: '3121' },
        { name: 'CajaRuralVillar', code: '3152' },
        { name: 'CajaSur', code: '0237' },
        { name: 'Caja Mar', code: '0240' },
        { name: 'Caja Mar', code: '3029' },
        { name: 'ING', code: '1465' },
        { name: 'Self Bank', code: '1490' },
        { name: 'Active Bank', code: '1800' },
        { name: 'Abanca', code: '2080' },
        { name: 'Ibercaja', code: '2085' },
        { name: 'Caja de ingenieros', code: '3025' },
        { name: 'Arquia', code: '3183' },
        { name: 'ACF', code: '3524' },
        { name: 'Open bank', code: '0073' },
        { name: 'Renta 4 Bank', code: '0083' },
        { name: 'Bestinver', code: '3574' },
        { name: 'Evo', code: '0239' },
        { name: 'Cetelem', code: '0225' },
        { name: 'Liberbank', code: '2048' },
        { name: 'Wizink', code: '01221' },
        { name: 'Pichincha', code: 'PRV72400000235' }
    ],
    arrayPhrases: [
        'alcanza el equilibrio',
        'conoce de ti, lo que tu banco ya sabe',
        'compártelo con quien tú quieras',
        'toma el control de tus finanzas'
    ],
    categories: [
        { id: 'C1', name: 'HISTÓRICO DE PAGOS' },
        { id: 'C2', name: 'GENERACIÓN DE AHORRO' },
        { id: 'C3', name: 'INDEPENDENCIA FINANCIERA' },
        { id: 'C4', name: 'CAPACIDAD FINANCIERA' },
        { id: 'C5', name: 'ANTIGÜEDAD DE CUENTA Y NÓMINA' }
    ],

    getChannels: (c) => {
        return c === '3' || c === '4';
    },

    phrasesWhatsApp: [
        '¿Conoces Akana? Descubre el servicio que te ayudará mantener en forma tu Salud Financiera. Además, podrás disfrutar de tips de ahorro para manejar mejor tu dinero. Regístrate aquí: https://www.akana.es'
    ],
    timeLoading: 300
};
